import { gql } from '@apollo/client';
import { Commande } from '../../fragments/commande/commande.fragments';

export const QUERY_GET_MY_ORDER_IN_CLASSE = gql`
  query QueryGetMyOrderInClasse($id: ID!) {
    getMyOrdersInClasse(userId: $id) {
      firstname
      lastname
      commandes {
        id
        attributes {
          ...DetailsCommande
        }
      }
    }
  }
  ${Commande.fragments.detailsCommande}
`;
